'use client';
import * as React from "react";
/**
 * Context used communicate with a child menu item that it is a trigger for a submenu
 */ const MenuSplitGroupContext = React.createContext(undefined);
export const menuSplitGroupContextDefaultValue = {
    setMultiline: ()=>null
};
export const MenuSplitGroupContextProvider = MenuSplitGroupContext.Provider;
export const useMenuSplitGroupContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(MenuSplitGroupContext)) !== null && _React_useContext !== void 0 ? _React_useContext : menuSplitGroupContextDefaultValue;
};
export const useIsInMenuSplitGroup = ()=>{
    const context = useMenuSplitGroupContext_unstable();
    return context !== menuSplitGroupContextDefaultValue;
};
